import { render, staticRenderFns } from "./glory.vue?vue&type=template&id=779c2dde"
import script from "./glory.vue?vue&type=script&lang=js"
export * from "./glory.vue?vue&type=script&lang=js"
import style0 from "./glory.vue?vue&type=style&index=0&id=779c2dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports